import { GameVersion } from 'app/frontend/types/custom/CharacterClass'

export const difficulties = [
  'mythic',
  'heroic',
  'normal',
  'raid_finder',
] as const

export const difficultiesLabels = {
  mythic: 'Mythic',
  heroic: 'Heroic',
  normal: 'Normal',
  raid_finder: 'LFR',
} as const

export const difficultiesTrackLabels = {
  mythic: 'Myth',
  heroic: 'Hero',
  normal: 'Champion',
  raid_finder: 'Veteran',
} as const

export const difficultiesILVLDeficit = {
  Mythic: 0,
  Heroic: -13,
  Normal: -26,
  LFR: -39,
}

export const difficultiesTextColors = {
  mythic: 'text-quality-legendary ',
  heroic: 'text-quality-epic',
  normal: 'text-quality-rare',
  raid_finder: 'text-foreground',
}

type Difficulty = typeof difficulties[number]
export default Difficulty

export const difficultiesByGameVersion: Record<
  GameVersion,
  readonly Difficulty[]
> = {
  live: difficulties,
  classic_progression: ['heroic', 'normal'],
  classic_era: ['normal'],
  classic_anniversary: ['normal'],
}

export const defaultDifficultyByGameVersion: Record<GameVersion, Difficulty> = {
  live: 'mythic',
  classic_progression: 'heroic',
  classic_era: 'normal',
  classic_anniversary: 'normal',
}
